import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-applicant-preview-basic',
  templateUrl: './applicant-preview-basic.component.html',
  styleUrls: ['./applicant-preview-basic.component.scss']
})
export class ApplicantPreviewBasicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
